"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyDeletedContractV2 = exports.LoyaltyUpdatedContractV2 = exports.LoyaltyDeleteEventDataV2Contract = exports.LoyaltyUpdateEventDataV2Contract = void 0;
const enums_1 = require("../enums");
const events_1 = require("@getgreenline/events");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class BaseLoyaltyEventDataV2Contract {
}
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "creditAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "creditAmountPer", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "deletedAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "isDefault", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "isEnabled", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "maximumRedeemable", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "merchantId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "minimumRedeemable", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "minimumRequiredPurchase", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], BaseLoyaltyEventDataV2Contract.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(enums_1.LoyaltyTypes)
], BaseLoyaltyEventDataV2Contract.prototype, "type", void 0);
class LoyaltyUpdateEventDataV2Contract extends BaseLoyaltyEventDataV2Contract {
}
exports.LoyaltyUpdateEventDataV2Contract = LoyaltyUpdateEventDataV2Contract;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateNested)({ each: true })
], LoyaltyUpdateEventDataV2Contract.prototype, "discounts", void 0);
class LoyaltyDeleteEventDataV2Contract extends BaseLoyaltyEventDataV2Contract {
}
exports.LoyaltyDeleteEventDataV2Contract = LoyaltyDeleteEventDataV2Contract;
class LoyaltyUpdatedContractV2 extends events_1.EventsV3.EventModels.EventContractV3 {
    constructor(params) {
        super(params);
        this.data.attributes = events_1.GreenlineEvent.create(LoyaltyUpdateEventDataV2Contract, params.attributes);
    }
}
exports.LoyaltyUpdatedContractV2 = LoyaltyUpdatedContractV2;
class LoyaltyDeletedContractV2 extends events_1.EventsV3.EventModels.EventContractV3 {
    constructor(params) {
        super(params);
        this.data.attributes = events_1.GreenlineEvent.create(LoyaltyDeleteEventDataV2Contract, params.attributes);
    }
}
exports.LoyaltyDeletedContractV2 = LoyaltyDeletedContractV2;
//# sourceMappingURL=loyalty.js.map